<template>
  <div class="guarantor-new">
    <div class="gua-form-step-container">
      <div class="form-scroller">
        <vue-scroll>
        <Form ref="newForm" :model="guaModel"
          @on-validate="onValidate"
          :rules="modelValidate"
          label-position="left"
          :label-width="180">
          <FormItem label="业务编号" prop="orderNumber">
            <Input
              :disabled="data.orderNumber"
              v-model="guaModel.orderNumber"
              placeholder="输入业务编号(如有)" />
          </FormItem>
          <FormItem label="经办机构" prop="guarantorName">
            <Input
              :disabled="$store.getters.userInfo.type===3"
              v-model="guaModel.guarantorName"
              placeholder="输入经办机构名称" />
          </FormItem>
          <!-- <FormItem label="经办机构社会信用代码" prop="guarantorBusinessLicense">
            <Input v-model="guaModel.guarantorBusinessLicense" placeholder="输入经办机构社会信用代码" />
          </FormItem>
          <FormItem label="经办机构地址" prop="guarantorAddress">
            <Input v-model="guaModel.guarantorAddress" placeholder="输入经办机构地址" />
          </FormItem> -->
          <FormItem label="受益人" prop="beneficiary">
            <Input v-model="guaModel.beneficiary" placeholder="输入受益人名称" />
          </FormItem>
          <!-- <FormItem label="受益人社会信用代码" prop="beneficiaryBusinessLicense">
            <Input v-model="guaModel.beneficiaryBusinessLicense" placeholder="输入受益人社会信用代码" />
          </FormItem>
          <FormItem label="受益人地址" prop="beneficiaryAddress">
            <Input v-model="guaModel.beneficiaryAddress" placeholder="输入受益人地址" />
          </FormItem> -->
          <FormItem label="缴存单位" prop="guaranteed">
            <Input v-model="guaModel.guaranteed" placeholder="输入缴存单位名称" />
          </FormItem>
          <!-- <FormItem label="缴存单位社会信用代码" prop="guaranteedBusinessLicense">
            <Input v-model="guaModel.guaranteedBusinessLicense" placeholder="输入缴存单位社会信用代码" />
          </FormItem>
          <FormItem label="缴存单位地址" prop="guaranteedAddress">
            <Input v-model="guaModel.guaranteedAddress" placeholder="输入缴存单位地址" />
          </FormItem> -->
          <!-- <FormItem label="担保种类" prop="variety">
            <Select v-model="guaModel.variety" filterable>
              <Option v-for="(tp,idx) in guaTypes" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
            </Select>
          </FormItem> -->
          <FormItem label="实缴金额(元)" prop="amount">
            <InputNumber :min="0" :step="10000"
              style="width: 150px;display:inline-block"
              v-model="guaModel.amount"
              placeholder="输入实缴金额(元)"></InputNumber>
            <Divider type="vertical" v-if="guaModel.amount" />
            <h3 style="display:inline-block" v-if="guaModel.amount"> {{`¥ ${guaModel.amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="guaModel.amount" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guaModel.amount)}}</h3>
          </FormItem>
          <FormItem label="造价比(%)" prop="amountCostRatio">
            <h3>{{Math.round(guaModel.amountCostRatio*10000)/100}}%</h3>
          </FormItem>
          <FormItem label="缴纳时间" prop="gStartDate">
            <DatePicker v-model="guaModel.gStartDate"
              type="date"
              placement="bottom-end"
              placeholder="选择缴纳时间"
              style="width: 200px"></DatePicker>
          </FormItem>
          <FormItem label="经办人" prop="opName">
            <Input v-model="guaModel.opName" placeholder="输入经办人名称" />
          </FormItem>
          <FormItem label="经办人联系电话" prop="opContactTel">
            <Input v-model="guaModel.opContactTel" placeholder="输入经办人联系电话" />
          </FormItem>
          <FormItem :label="fileReq.name" :prop="`attachments[${getAttachmentIndex(idx)}].url`"
            v-for="(fileReq,idx) in fileRequirements"
            :key="idx"
            :rules="fileReq.isRequired?[{required:true,message:'必填',trigger:'blur'}]:null">
            <Upload
              :data="OSSParam"
              :before-upload="handleBeforeUpload"
              :multiple="false"
              :on-progress="handleUploadProgress"
              :on-success="handleUploadSuccess"
              :format="fileReq.formats!=='*'?fileReq.formats.split(','):[]"
              :on-format-error="handleFormatError"
              :show-upload-list="true"
              :action="uploadParams.host">
              <Poptip trigger="hover" placement="right">
                <Button @click="getOSSParams(idx+1, fileReq.name, 3)"><Icon type="ios-cloud-upload-outline"></Icon>上传附件</Button>
                <div slot="content">
                  <p>{{fileReq.description}}</p>
                  <p>格式限制：{{fileReq.formats}}</p>
                  <p>大小限制：{{fileReq.maxLength}}kb</p>
                </div>
              </Poptip>
            </Upload>
            <div class="contract" v-if="guaModel.attachments&&guaModel.attachments instanceof Array&&guaModel.attachments.length">
              <template v-if="currentFileRequirement(idx)&&currentFileRequirement(idx).urls&&(currentFileRequirement(idx).urls instanceof Array)&&currentFileRequirement(idx).urls.length">
                <div class="contract-thumb" v-for="(item,upIdx) in currentFileRequirement(idx).urls" :key="upIdx">
                  <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                  <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
                  <div class="contract-thumb-cover">
                    <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='image'" @click="handleImgPreview(currentFileRequirement(idx).urls, upIdx)"></Icon>
                    <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='file'" @click="previewImgUrl=item;showPreview=true"></Icon>
                    <Icon type="ios-trash-outline" @click="removeAttachmentItem(item,idx)"></Icon>
                  </div>
                </div>
              </template>
            </div>
          </FormItem>
          <div class="padding-top-20"></div>
        </Form>
        </vue-scroll>
      </div>
      
      <div class="bottom-buttons">
        <Row :gutter="16">
          <Col span="4"><Button type="primary" ghost size="large" style="display:inline" long @click="backward">上一步</Button></Col>
          <Col span="16"><Button type="primary" size="large" style="display:inline" long @click="submit">下一步</Button></Col>
          <Col span="4"><Button type="info" size="large" style="display:inline" long @click="draft">存草稿</Button></Col>
        </Row>
      </div>
      <Spin fix v-if="uploading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>上传中...{{uploadingProgress}}%</div>
      </Spin>
    </div>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null" width="1200">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <iframe :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix==='pdf'" width="100%" height="800"></iframe>
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix!='pdf'">查看</a>
    </Modal>
    <image-preview
      :minScale="1"
      :image-urls="imageUrls"
      :visible.sync="visiblePreviewer"
      :start-position="startPosition"></image-preview>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'guarantee-new',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      guaModel: {
        orderNumber: null,
        guarantorName: null,
        guarantorBusinessLicense: null,
        guarantorAddress: null,
        beneficiary: null,
        beneficiaryBusinessLicense: null,
        beneficiaryAddress: null,
        guaranteed: null,
        guaranteedBusinessLicense: null,
        guaranteedAddress: null,
        amount: 0,
        fee: null,
        amountCostRatio: 0,
        variety: 99,
        counterRatio: 0,
        counterCash: 0,
        counter3rdparty: 0,
        counterMortgage: 0,
        counterOther: 0,
        counterTotal: 0,
        gMethod: 0,
        gStartDate: null,
        gEndDate: null,
        gFeeRate: 0,
        opName: null,
        opContactTel: null,
        contractOssKeys: [],
        attachments: []
      },
      modelValidate: {
        guarantorName: [
          { required: true, message: '请填写经办机构', trigger: 'blur' }
        ],
        beneficiary: [
          { required: true, message: '请填写受益人', trigger: 'blur' }
        ],
        guaranteed: [
          { required: true, message: '请填写被保证人', trigger: 'blur' }
        ],
        amount: [
          { required: true, type: 'number', message: '请填写担保金额', trigger: 'blur' }
        ],
        amountCostRatio: [
          { required: true, type: 'number', message: '请填写保额造价比', trigger: 'blur' }
        ],
        // variety: [
        //   { required: true, type: 'number', message: '请选择担保种类', trigger: 'blur' }
        // ],
        gStartDate: [
          { required: true, type: 'date', message: '请填写起始日期', trigger: 'change' },
          // { type: 'date', message: '必须是日期格式', trigger: 'change' }
        ],
        opName: [
          { required: true, message: '请填写上报人', trigger: 'blur' }
        ],
        opContactTel: [
          { required: true, message: '请填写联系方式', trigger: 'blur' }
        ]
      },
      guaTypes: [],
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      curOSSParamIndex: null,
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: '',
        fileIndex: 0
      },
      uploadList: [],
      uploadedContractArray: [],
      previewImgUrl: null,
      showPreview: false,
      fileRequirements: [],
      fileRequirementsUploaded: [],
      visiblePreviewer: false,
      imageUrls: [],
      startPosition: 0,
      uploading: false,
      uploadingProgress: 0
    }
  },
  watch: {
    'guaModel.amount': function (newVal) {
      try {
        this.guaModel.amountCostRatio = Math.round(newVal / this.data.project.cost * 10000) / 10000
        this.reCalcRatios()
      } catch (e) {
        this.guaModel.amountCostRatio = 0
        this.guaModel.counterRatio = 0
        this.reCalcRatios()
      }
    }
  },
  mounted () {
    this.initGuaTypes()
    if (!this.data.cityId) {
      this.$router.push({path: '/receipts/new/step1'})
    } else {
      if (this.data.project) {
        Object.assign(this.guaModel, this.data)
      }
    }
    if (this.$store.getters.userInfo.type === 3) {
      this.guaModel.guarantorName = this.$store.getters.guarantorInfo.name
    }
    if (!this.guaModel.beneficiary && this.$store.getters.supervisorInfo && this.$store.getters.supervisorInfo.name) {
      this.guaModel.beneficiary = this.$store.getters.supervisorInfo.name
      this.guaModel.beneficiaryBusinessLicense = this.$store.getters.supervisorInfo.businessLicense
    }
    // if (!this.guaModel.beneficiary && this.data.owner) {
    //   this.guaModel.beneficiary = this.data.owner.name
    //   this.guaModel.beneficiaryBusinessLicense = this.data.owner.businessLicense
    // }
    if (this.guaModel.contractor && this.guaModel.contractor.name) {
      this.guaModel.guaranteed = this.guaModel.contractor.name
      this.guaModel.guaranteedBusinessLicense = this.guaModel.contractor.businessLicense
    }
    if (!this.guaModel.opName && this.$store.getters.userInfo && this.$store.getters.userInfo.displayName) {
      this.guaModel.opName = this.$store.getters.userInfo.displayName
      this.guaModel.opContactTel = this.$store.getters.userInfo.mobile
    }
    if (this.guaModel.gStartDate) {
      this.guaModel.gStartDate = new Date(this.guaModel.gStartDate)
      this.$nextTick()
    }
    if (this.guaModel.gEndDate) {
      this.guaModel.gEndDate = new Date(this.guaModel.gEndDate)
      this.$nextTick()
    }
    if (this.data.contractOssKeys && this.data.contractOssKeys instanceof Array && this.data.contractOssKeys.length) {
      this.procOssKeys(this.data.contractOssKeys)
    }
    this.listFileRequirements()
    this.uploadList = this.$refs.contractUploader.fileList
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getAttachmentIndex (fileReqIdx) {
      let fileReq = this.fileRequirements[fileReqIdx]
      return this.guaModel.attachments.findIndex(o => o.name === fileReq.name)
    },
    getSysConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    backward () {
      this.$emit('go-backward')
    },
    changeStartDate (date) {
      console.log('startdate changed')
      this.guaModel.gStartDate = date
    },
    changeEndDate (date) {
      this.guaModel.gEndDate = date
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    async initGuaTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantee.getGuaranteeVarieties().then(res => {
          this.guaTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    reCalcRatios () {
      console.log('recalculate ratios')
      let totalAmount = this.guaModel.amount
      this.guaModel.amountCostRatio = Math.round(totalAmount / this.data.project.cost * 10000) / 10000
    },
    async draft () {
      this.$Spin.show()
      let draft = {}
      Object.assign(draft, this.guaModel)
      // draft.guarantorId = this.data.guarantorId
      draft.amount = this.guaModel.amount * 100
      draft.fee = this.guaModel.fee * 100
      // draft.gStartDate = require('moment')(this.guaModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')
      // draft.gEndDate = require('moment')(this.guaModel.gEndDate).format('YYYY-MM-DD HH:mm:ss')
      this.$Api.Receipt.draftReceipt(draft).then(() => {
        this.$Message.success('操作成功')
        this.$Spin.hide()
        this.$router.push('/receipts/list')
      }).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
    },
    currentFileRequirement (idx) {
      let req = this.fileRequirements[idx]
      let att = this.guaModel.attachments.find(o => o.name === req.name)
      return att
    },
    async listFileRequirements () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantee.listFileRequirements({
          guarantorId: this.data.guarantorId,
          cityId: this.data.cityId,
          industryId: this.data.industryId,
          type: 99
        }, 1, -1).then(res => {
          console.log(res)
          this.fileRequirementsUploaded = []
          let list = []
          if (res.data.length > 0) {
            list = res.data.sort((a, b) => {
              return a.tid - b.tid
            })
          }
          list.forEach((f) => {
            this.$nextTick(() => {
              let att = this.guaModel.attachments.find(o => o.name === f.name)
              if (!att) {
                console.log('null')
                this.guaModel.attachments.push({
                  id: f.tid,
                  ossKeys: [],
                  fileUrls: [],
                  name: f.name,
                  url: null,
                  urls: []
                })
              }
              this.fileRequirementsUploaded.push({
                id: f.tid,
                ossKeys: [],
                fileUrls: []
              })
            })
          })
          if (this.guaModel.attachments && this.guaModel.attachments.length) {
            this.$nextTick(() => {
              this.guaModel.attachments.forEach((att) => {
                att.urls = []
                let urls = att.url ? att.url.split(',') : []
                this.$nextTick(() => {
                  urls.forEach(async (u) => {
                    let itemUrl = u
                    if (u.indexOf('oss:') === 0) {
                      itemUrl = await this.procOssKey(u)
                      this.$nextTick(() => {
                        att.urls.push(itemUrl)
                        this.$nextTick(() => {})
                      })
                    }
                    // this.$nextTick(() => {
                    //   att.urls.push({
                    //     name: u,
                    //     status: 'finished',
                    //     url: itemUrl
                    //   })
                    //   this.$nextTick(() => {})
                    // })
                  })
                })
              })
            })
          }
          this.fileRequirements = res.data
          // setTimeout(() => {
          //   this.fileRequirements = res.data
          // }, 1000)
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    getOSSParams (index, name, type = 1) {
      // type: 1-合同|2-竣工|3-其他
      this.$Api.Guarantee.getUploadParams(type).then((res) => {
        console.log(res)
        this.uploadParams = {
          name: name,
          accessid: res.accessid,
          host: res.host,
          policy: res.policy,
          signature: res.signature,
          callbackbody: res.callbackbody,
          key: res.dir,
          expire: res.expire
        }
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
        this.curOSSParamIndex = index    // 上传控件序号
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve, reject) => {
        try {
          let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
          if (surfix.indexOf('?')) {
            surfix = surfix.substring(0, surfix.indexOf('?'))
          }
          let type = 'image'
          switch (surfix) {
            case 'jpg':
              type = 'image'
              break
            case 'jpeg':
              type = 'image'
              break
            case 'png':
              type = 'image'
              break
            case 'gif':
              type = 'image'
              break
            case 'pdf':
              type = 'file'
              break
            case 'doc':
              type = 'file'
              break
            case 'docx':
              type = 'file'
              break
            case 'xls':
              type = 'file'
              break
            case 'xlsx':
              type = 'file'
              break
            case 'ppt':
              type = 'file'
              break
            case 'pptx':
              type = 'file'
              break
            default:
              type = 'file'
              break
          }
          let obj = {
            name: k,
            url,
            type,
            surfix
          }
          resolve(obj)
          return obj
        } catch (er) {
          reject(er)
        }
      })
    },
    procOssKeys (keys) {
      keys.forEach(async (k) => {
        try {
          if (typeof(k) === 'string') {
            let keyObj = await this.procOssKey(k)
            this.uploadedContractArray.push(keyObj)
          } else if (typeof(k) === 'object' && k.url) {
            this.uploadedContractArray.push({
              name: k.name,
              url: k.url,
              type: k.type,
              surfix: k.prefix
            })
          }
        } catch (e) {
          console.log(e)
        }
      })
      this.$nextTick(() => {
        this.uploadList = this.$refs.contractUploader.fileList
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    removeItem (item) {
      let idx = this.uploadedContractArray.findIndex(o => o.name === item.name)
      this.uploadedContractArray.splice(idx, 1)
      let modelIdx = this.guaModel.contractOssKeys.findIndex(o => o === item.name)
      this.guaModel.contractOssKeys.splice(modelIdx, 1)
    },
    removeAttachmentItem (item, attachIdx) {
      let attach = this.currentFileRequirement(attachIdx)
      let idx = attach.urls.findIndex(o => o.name === item.name)
      attach.urls.splice(idx, 1)
      let keys = attach.url.split(',')
      keys.splice(idx, 1)
      keys = keys.join(',')
      console.log(keys)
      attach.url = keys
    },
    handleBeforeUpload (file) {
      let filename = this.uploadParams.key + this.randomString(10) + this.getSuffix(file.name)
      this.OSSParams[this.curOSSParamIndex] = {
        name: this.uploadParams.name,
        filename: file.name,
        key: filename,
        policy: this.uploadParams.policy,
        OSSAccessKeyId: this.uploadParams.accessid,
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: this.uploadParams.signature,
        fileIndex: this.curOSSParamIndex
      }
      this.OSSParam.name = this.uploadParams.name
      this.OSSParam.filename = file.name
      this.OSSParam.key = filename
      this.OSSParam.policy = this.uploadParams.policy
      this.OSSParam.OSSAccessKeyId = this.uploadParams.accessid
      this.OSSParam.success_action_status = '200'   // 让服务端返回200,不然，默认会返回204
      this.OSSParam.signature = this.uploadParams.signature
      this.OSSParam.fileIndex = this.curOSSParamIndex
      this.$nextTick(() => {
        this.uploading = true
        this.uploadingProgress = 0
      })
    },
    handleUploadProgress (event) {
      let percent = event.percent
      this.uploadingProgress = Math.round(percent * 100) / 100
    },
    async handleUploadSuccess (response, file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      let ossParam = this.OSSParams.filter((item) => {
        return item.filename === file.name
      })[0]
      console.log(ossParam)
      let filename = 'oss:' + ossParam.key
      file.name = filename
      this.$nextTick(async () => {
        await this.procOssKey(filename).then(async (keyObj) => {
          console.log(keyObj.url)
          file.url = keyObj.url
          if (ossParam.fileIndex > 0) {
            this.fileRequirementsUploaded[ossParam.fileIndex - 1].ossKeys.push(filename)
            this.fileRequirementsUploaded[ossParam.fileIndex - 1].fileUrls.push(keyObj.url)
            let attachExist = this.guaModel.attachments.filter((a) => {
              return a.name === ossParam.name
            })
            if (attachExist && attachExist.length) {
              if (typeof(attachExist[0].url) === 'string') {
                let urls = attachExist[0].url.split(',')
                if (urls.length) {
                  urls.push(filename)
                } else {
                  urls = [filename]
                }
                attachExist[0].url = urls.join(',')
              } else if (attachExist[0].url instanceof Array) {
                attachExist[0].url = attachExist[0].url.push(filename).join(',')
              } else {
                attachExist[0].url = filename
              }
              if (attachExist[0].urls) {
                attachExist[0].urls.push(keyObj)
              } else {
                console.log(222)
                attachExist[0].urls = []
                this.$nextTick(() => {
                  attachExist[0].urls.push(keyObj)
                  console.log(attachExist[0].urls)
                })
              }
            } else {
              console.log(111)
              this.guaModel.attachments.push({
                name: ossParam.name,
                type: 3,
                url: filename,
                urls: [keyObj]
              })
            }
          } else {
            // 担保合同
            if (this.guaModel.contractOssKeys === null) {
              this.guaModel.contractOssKeys = []
            }
            this.guaModel.contractOssKeys.push(filename)
            this.uploadedContractArray.push(keyObj)
          }
        })
        this.$nextTick(async () => {
          this.uploading = false
          this.uploadingProgress = 0
        })
      })
    },
    handleFormatError () {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '上传文件格式不正确。'
      })
      this.uploading = false
      this.uploadingProgress = 0
    },
    onValidate (prop, status, error) {
      console.log(prop, this.guaModel[prop], status, error)
    },
    async submit () {
      try {
        console.log('submit step4')
        this.$refs.newForm.validate((valid) => {
          console.log(valid)
          if (valid) {
            let keys = []
            this.uploadedContractArray.forEach((u) => {
              keys.push(u.name)
            })
            this.guaModel.attachments.forEach((a, idx) => {
              if (!a.url) {
                this.guaModel.attachments.splice(idx, 1)
              }
            })
            console.log(keys)
            let model = {}
            Object.assign(model, this.guaModel)
            model.amount *= 100
            model.fee *= 100
            // model.gStartDate = require('moment')(this.guaModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')
            // model.gEndDate = require('moment')(this.guaModel.gEndDate).format('YYYY-MM-DD HH:mm:ss')
            console.log(keys, model.contractOssKeys, model)
            this.$emit('finish-step4', model)
          }
        }).catch((errors, fields) => {
          console.log(errors, fields)
        })
      } catch (err) {
        console.log(err)
      }
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
    handleImgPreview (list, index) {
      this.imageUrls = list.map((l) => {return l.url})
      this.visiblePreviewer = true
      this.startPosition = index
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new {
  position: relative;
  height: 100%;
}
.gua-form-step-container {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  .form-scroller {
    flex: 1;
    overflow: auto;
  }
  .bottom-buttons {

  }
}
.joint-guarantor {
  padding: 15px 15px 25px 15px;
  border: 1px solid #e2e2e2;
  background: #f8f8f8;
  margin-bottom: 10px;
  position: relative;
  .remove-jointguarantor {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}
.contract {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}
.contract-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    width: 100%;
    cursor: pointer;
  }
  .contract-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .contract-thumb-cover{
    opacity: 1;
  }
  .contract-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
.uploading-loader{
  animation: ani-spin 1s linear infinite;
}
@keyframes ani-spin {
  from { transform: rotate(0deg);}
  50%  { transform: rotate(180deg);}
  to   { transform: rotate(360deg);}
}
</style>
